import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Pagination, PaginationItem, PaginationLink, Card, Nav, NavItem, NavLink, Alert, Badge, ButtonGroup, Spinner } from 'reactstrap';
import { useSearchParams } from 'react-router-dom';
import BreadCrumb from "../../../../../Components/Common/BreadCrumb";
import EmailTemplateContext from "../../../../../Components/Contexts/Management/EmailTemplateContext";
import SistemSablonlari from "./SistemSablonlari";
import { EpostaResimYuklemeEklentisi } from "../../../../../services/epostaResimYukle";
import { emailHatasi, getFreeTemplate, previewTemplate } from "../../../../../services/emailAyarService";

import 'ckeditor5/ckeditor5.css';

import { CKEditor } from '@ckeditor/ckeditor5-react';

import {
	ClassicEditor,
	AccessibilityHelp,
	Alignment,
	Autoformat,
	AutoImage,
	AutoLink,
	Autosave,
	Base64UploadAdapter,
	BlockQuote,
	Bold,
	Code,
	CodeBlock,
	Essentials,
	FindAndReplace,
	FontBackgroundColor,
	FontColor,
	FontFamily,
	FontSize,
	FullPage,
	GeneralHtmlSupport,
	Heading,
	Highlight,
	HorizontalLine,
	HtmlComment,
	HtmlEmbed,
	ImageBlock,
	ImageCaption,
	ImageInline,
	ImageInsert,
	ImageInsertViaUrl,
	ImageResize,
	ImageStyle,
	ImageTextAlternative,
	ImageToolbar,
	ImageUpload,
	Indent,
	IndentBlock,
	Italic,
	Link,
	LinkImage,
	List,
	ListProperties,
	Markdown,
	MediaEmbed,
	Mention,
	PageBreak,
	Paragraph,
	PasteFromMarkdownExperimental,
	PasteFromOffice,
	RemoveFormat,
	SelectAll,
	ShowBlocks,
	SourceEditing,
	SpecialCharacters,
	SpecialCharactersArrows,
	SpecialCharactersCurrency,
	SpecialCharactersEssentials,
	SpecialCharactersLatin,
	SpecialCharactersMathematical,
	SpecialCharactersText,
	Strikethrough,
	Style,
	Subscript,
	Superscript,
	TextPartLanguage,
	TextTransformation,
	Title,
	TodoList,
	Underline,
	Undo
} from 'ckeditor5';
import { useTranslation } from "react-i18next";
import i18n from "../../../../../i18n";

const Templates = () => {
  const { t } = useTranslation("moduller");
	useEffect(() => { document.title = i18n.t("moduller:emailsTemplates.emailTemalariFds"); }, []);

	// #573: iki sekme. "sistem" = sistemin kendi gönderdiği postalar (aktivasyon, şifre unuttum, ...), "denetmen" = eskiden bu sayfanın tamamı olan serbest şablon listesi.
	const [searchParams, setSearchParams] = useSearchParams();
	const sekme = searchParams.get('sekme') === 'denetmen' ? 'denetmen' : 'sistem';
	const sekmeDegistir = (k) => setSearchParams(k === 'sistem' ? {} : { sekme: k }, { replace: true });

	const { getEmailTemplates, addEmailTemplate, updateEmailTemplate, deleteEmailTemplate } = useContext(EmailTemplateContext);
	const [emailTemplates, setEmailTemplates] = useState([]);
	const [loading, setLoading] = useState(true);
	const [editingId, setEditingId] = useState(null);
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(10);
	const [totalPages, setTotalPages] = useState(1);
	const [search, setSearch] = useState("");
	const [modalOpen, setModalOpen] = useState(false);
	const [deleteModalOpen, setDeleteModalOpen] = useState(false);
	const [deleteId, setDeleteId] = useState(null);
	// WAS (until #583): const [newEmailTemplate, setNewEmailTemplate] = useState({ title: '', content: '' });
	// #583: the English twin (subject + body) sits next to the Turkish; a blank pair clears it, both filled makes the mail go out in English to an English recipient
	const [newEmailTemplate, setNewEmailTemplate] = useState({ title: '', content: '', titleEn: '', contentEn: '' });
	const [saveError, setSaveError] = useState(null);
	const [listError, setListError] = useState(null);
	const [editLoadingId, setEditLoadingId] = useState(null);
	const [onizleme, setOnizleme] = useState(null);   // { id, baslik, dil, veri, hata, yukleniyor }
	const [dropdownOpen, setDropdownOpen] = useState(false);

	const editorConfig = {
		toolbar: {
			items: [
				'undo',
				'redo',
				'|',
				'sourceEditing',
				'showBlocks',
				'findAndReplace',
				'textPartLanguage',
				'|',
				'heading',
				'style',
				'|',
				'fontSize',
				'fontFamily',
				'fontColor',
				'fontBackgroundColor',
				'|',
				'bold',
				'italic',
				'underline',
				'strikethrough',
				'subscript',
				'superscript',
				'code',
				'removeFormat',
				'|',
				'specialCharacters',
				'horizontalLine',
				'pageBreak',
				'link',
				'insertImage',
				'mediaEmbed',
				'highlight',
				'blockQuote',
				'codeBlock',
				'htmlEmbed',
				'|',
				'alignment',
				'|',
				'bulletedList',
				'numberedList',
				'todoList',
				'outdent',
				'indent'
			],
			shouldNotGroupWhenFull: true
		},
		plugins: [
			AccessibilityHelp,
			Alignment,
			Autoformat,
			AutoImage,
			AutoLink,
			Autosave,
			Base64UploadAdapter,
			BlockQuote,
			Bold,
			Code,
			CodeBlock,
			Essentials,
			FindAndReplace,
			FontBackgroundColor,
			FontColor,
			FontFamily,
			FontSize,
			FullPage,
			GeneralHtmlSupport,
			Heading,
			Highlight,
			HorizontalLine,
			HtmlComment,
			HtmlEmbed,
			ImageBlock,
			ImageCaption,
			ImageInline,
			ImageInsert,
			ImageInsertViaUrl,
			ImageResize,
			ImageStyle,
			ImageTextAlternative,
			ImageToolbar,
			ImageUpload,
			Indent,
			IndentBlock,
			Italic,
			Link,
			LinkImage,
			List,
			ListProperties,
			Markdown,
			MediaEmbed,
			Mention,
			PageBreak,
			Paragraph,
			PasteFromMarkdownExperimental,
			PasteFromOffice,
			RemoveFormat,
			SelectAll,
			ShowBlocks,
			SourceEditing,
			SpecialCharacters,
			SpecialCharactersArrows,
			SpecialCharactersCurrency,
			SpecialCharactersEssentials,
			SpecialCharactersLatin,
			SpecialCharactersMathematical,
			SpecialCharactersText,
			Strikethrough,
			Style,
			Subscript,
			Superscript,
			TextPartLanguage,
			TextTransformation,
			Title,
			TodoList,
			Underline,
			Undo
		],
		fontFamily: {
			supportAllValues: true
		},
		fontSize: {
			options: ['default', 8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72],
			supportAllValues: true
		},
		heading: {
			options: [
				{
					model: 'paragraph',
					title: 'Paragraph',
					class: 'ck-heading_paragraph'
				},
				{
					model: 'heading1',
					view: 'h1',
					title: 'Heading 1',
					class: 'ck-heading_heading1'
				},
				{
					model: 'heading2',
					view: 'h2',
					title: 'Heading 2',
					class: 'ck-heading_heading2'
				},
				{
					model: 'heading3',
					view: 'h3',
					title: 'Heading 3',
					class: 'ck-heading_heading3'
				},
				{
					model: 'heading4',
					view: 'h4',
					title: 'Heading 4',
					class: 'ck-heading_heading4'
				},
				{
					model: 'heading5',
					view: 'h5',
					title: 'Heading 5',
					class: 'ck-heading_heading5'
				},
				{
					model: 'heading6',
					view: 'h6',
					title: 'Heading 6',
					class: 'ck-heading_heading6'
				}
			]
		},
		htmlSupport: {
			allow: [
				{
					name: /^.*$/,
					styles: true,
					attributes: true,
					classes: true
				}
			]
		},
		// 2026-10-30 (Bilge): a picked or dropped image goes to POST /email/templates/images and the editor gets its public address back
		extraPlugins: [EpostaResimYuklemeEklentisi],
		image: {
			upload: { types: ['jpeg', 'png', 'gif', 'webp'] },
			toolbar: [
				'toggleImageCaption',
				'imageTextAlternative',
				'|',
				'imageStyle:inline',
				'imageStyle:wrapText',
				'imageStyle:breakText',
				'|',
				'resizeImage'
			]
		},
		language: 'tr',
		link: {
			addTargetToExternalLinks: true,
			defaultProtocol: 'https://',
			decorators: {
				toggleDownloadable: {
					mode: 'manual',
					label: 'Downloadable',
					attributes: {
						download: 'file'
					}
				}
			}
		},
		list: {
			properties: {
				styles: true,
				startIndex: true,
				reversed: true
			}
		},
		mention: {
			feeds: [
				{
					marker: '@',
					feed: [
					]
				}
			]
		},
		placeholder: 'Type or paste your content here!',
		style: {
			definitions: [
				{
					name: 'Article category',
					element: 'h3',
					classes: ['category']
				},
				{
					name: 'Title',
					element: 'h2',
					classes: ['document-title']
				},
				{
					name: 'Subtitle',
					element: 'h3',
					classes: ['document-subtitle']
				},
				{
					name: 'Info box',
					element: 'p',
					classes: ['info-box']
				},
				{
					name: 'Side quote',
					element: 'blockquote',
					classes: ['side-quote']
				},
				{
					name: 'Marker',
					element: 'span',
					classes: ['marker']
				},
				{
					name: 'Spoiler',
					element: 'span',
					classes: ['spoiler']
				},
				{
					name: 'Code (dark)',
					element: 'pre',
					classes: ['fancy-code', 'fancy-code-dark']
				},
				{
					name: 'Code (bright)',
					element: 'pre',
					classes: ['fancy-code', 'fancy-code-bright']
				}
			]
		},
	};

	const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

	const fetchTemplates = async () => {
		try {
			setLoading(true);
			const data = await getEmailTemplates(page, limit, search);
			setEmailTemplates(data.data);
			setTotalPages(data.totalPages);
		} catch (error) {
			console.error("Error fetching templates:", error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		async function run() { await fetchTemplates(); } run();
	}, [page, limit, search]);

	const toggleModal = () => {
		if (modalOpen) {
			setEditingId(null);
			// WAS (until #583): setNewEmailTemplate({ title: '', content: '' });
			setNewEmailTemplate({ title: '', content: '', titleEn: '', contentEn: '' });
		}
		setModalOpen(!modalOpen);
	};

	const toggleDeleteModal = (id) => {
		setDeleteId(id);
		setDeleteModalOpen(!deleteModalOpen);
	};

	const handleSave = async () => {
		try {
			if (editingId) {
				await updateEmailTemplate(editingId, newEmailTemplate);
			} else {
				await addEmailTemplate(newEmailTemplate);
			}
			toggleModal();
			fetchTemplates();
		} catch (error) {
			console.error("Error saving template:", error);
			setSaveError(emailHatasi(error).message);   // #583: the backend's own refusal (too long ...) stays in the window
		}
	};

	const confirmDelete = async () => {
		try {
			await deleteEmailTemplate(deleteId);
			setDeleteModalOpen(false);
			fetchTemplates();
		} catch (error) {
			console.error("Error deleting template:", error);
		}
	};

	// WAS (until #583): the list row was enough, it only had the Turkish.
	// const handleEdit = (template) => {
	// 	setEditingId(template.email_template_id);
	// 	setNewEmailTemplate({
	// 		title: template.email_template_title,
	// 		content: template.email_template_content
	// 	});
	// 	toggleModal();
	// };
	const handleEdit = async (template) => {
		setEditLoadingId(template.email_template_id);
		setListError(null);
		try {
			// #583: the single read carries the English twin next to the Turkish original
			const full = await getFreeTemplate(template.email_template_id);
			setEditingId(template.email_template_id);
			setNewEmailTemplate({
				title: full.email_template_title || '',
				content: full.email_template_content || '',
				titleEn: full.email_template_title_en || '',
				contentEn: full.email_template_content_en || '',
			});
			setSaveError(null);
			setModalOpen(true);
		} catch (error) {
			setListError(error.message);
		} finally {
			setEditLoadingId(null);
		}
	};

	// #583: what a recipient of that language would get (the backend falls back to the whole Turkish text when the English subject or body is blank)
	const onizlemeAc = async (id, baslik, dil) => {
		setOnizleme({ id, baslik, dil, veri: null, hata: null, yukleniyor: true });
		try {
			const veri = await previewTemplate(id, dil);
			setOnizleme({ id, baslik, dil, veri, hata: null, yukleniyor: false });
		} catch (error) {
			setOnizleme({ id, baslik, dil, veri: null, hata: error.message, yukleniyor: false });
		}
	};

	const renderPagination = () => {
		const paginationItems = [];
		const maxPagesToShow = 5;

		for (let i = 1; i <= totalPages; i++) {
			if (totalPages > maxPagesToShow) {
				if (i === 1 || i === totalPages || (i >= page - 1 && i <= page + 1)) {
					paginationItems.push(
						<PaginationItem key={i} active={i === page}>
							<PaginationLink onClick={() => setPage(i)}>{i}</PaginationLink>
						</PaginationItem>
					);
				} else if (i === 2 || i === totalPages - 1) {
					paginationItems.push(
						<PaginationItem key={i} disabled>
							<PaginationLink>...</PaginationLink>
						</PaginationItem>
					);
				}
			} else {
				paginationItems.push(
					<PaginationItem key={i} active={i === page}>
						<PaginationLink onClick={() => setPage(i)}>{i}</PaginationLink>
					</PaginationItem>
				);
			}
		}
		return paginationItems;
	};

	return (
		<div className="page-content">
			<Container fluid>
				<BreadCrumb title={t("emailsTemplates.temalar")} pageTitle={t("emailsTemplates.emails")} />
				<Nav tabs className="nav-tabs-custom mb-3">
					{[['sistem', 'emailsTemplates.sekmeSistem'], ['denetmen', 'emailsTemplates.sekmeDenetmen']].map(([k, etiket]) => (
						<NavItem key={k}>
							<NavLink href="#" className={`fw-semibold ${sekme === k ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); sekmeDegistir(k); }}>
								{t(etiket)}
							</NavLink>
						</NavItem>
					))}
				</Nav>
				{sekme === 'denetmen' ? (<>{/* eski sayfa, olduğu gibi (girintisi değiştirilmedi: fark küçük kalsın) */}
				{listError && <Alert color="danger" className="py-2" toggle={() => setListError(null)}>{listError}</Alert>}
				<Card className="p-3">
					<Row>
						<Col md="1">
							<Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
								<DropdownToggle color="primary" caret>
									{t("emailsTemplates.gosterim", { limit })}
								</DropdownToggle>
								<DropdownMenu>
									<DropdownItem onClick={() => setLimit(10)}>10</DropdownItem>
									<DropdownItem onClick={() => setLimit(25)}>25</DropdownItem>
									<DropdownItem onClick={() => setLimit(50)}>50</DropdownItem>
									<DropdownItem onClick={() => setLimit(100)}>100</DropdownItem>
								</DropdownMenu>
							</Dropdown>
						</Col>
						<Col md="3">
							<Input
								type="text"
								placeholder={t("emailsTemplates.arama")}
								value={search}
								onChange={(e) => setSearch(e.target.value)}
							/>
						</Col>
						<Col md="8" className="text-end">
							<Button color="primary" onClick={toggleModal}>{t("emailsTemplates.yeniEkle")}</Button>
						</Col>
					</Row>
				</Card>
				{loading ? (
					<div>{t("common:yukleniyor")}</div>
				) : (
					<>
						<Card className="pt-3 pe-3 ps-3">
							<Table responsive bordered striped>
								<thead>
									<tr style={{height: '40px'}}>
										<th>{t("emailsTemplates.baslik")}</th>
										<th>{t("emailsTemplates.ingilizce")}</th>
										<th>{t("emailsTemplates.islemler")}</th>
									</tr>
								</thead>
								<tbody>
									{emailTemplates.map((template) => (
										<tr style={{height: '65px'}} key={template.email_template_id}>
											<td>{template.email_template_title}</td>
											<td>
												{template.has_en
													? <Badge color="success">{t("emailsSistem.ingilizceHazir")}</Badge>
													: <Badge color="secondary" title={t("emailsTemplates.ingilizceKurali")}>{t("emailsTemplates.sadeceTurkce")}</Badge>}
											</td>
											<td>
												<Button
													color="warning"
													className="me-2"
													disabled={editLoadingId !== null} onClick={() => handleEdit(template)}
												>
													{t("common:duzenle")}
												</Button>
												<ButtonGroup className="me-2">
													<Button color="light" onClick={() => onizlemeAc(template.email_template_id, template.email_template_title, 1)}>{t("emailsSistem.onizleTr")}</Button>
													<Button color="light" onClick={() => onizlemeAc(template.email_template_id, template.email_template_title, 2)}>{t("emailsSistem.onizleEn")}</Button>
												</ButtonGroup>
												<Button color="primary" onClick={() => toggleDeleteModal(template.email_template_id)}>
													{t("common:sil")}
												</Button>
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						</Card>
						<Pagination className="pagination justify-content-center">
							{renderPagination()}
						</Pagination>
					</>
				)}

				<Modal isOpen={modalOpen} toggle={toggleModal} size="xl"> {/* Modal boyutunu artırdık */}
					<ModalHeader toggle={toggleModal}>{editingId ? t("emailsTemplates.emailSablonunuDuzenle") : t("emailsTemplates.yeniEmailSablonuEkle")}</ModalHeader>
					<ModalBody>
						{saveError && <Alert color="danger" className="py-2" toggle={() => setSaveError(null)}>{saveError}</Alert>}
						<h6 className="border-bottom pb-2 mb-3">{t("emailsSistem.turkce")}</h6>
						<Row className="mb-3">
							<Col md="12">
								<Input
									type="text"
									name="title"
									placeholder={t("emailsTemplates.baslik")}
									value={newEmailTemplate.title}
									onChange={(e) => setNewEmailTemplate(prev => ({ ...prev, title: e.target.value }))}
								/>
							</Col>
						</Row>
						<Row className="mb-3">
							<Col md="12">
								{modalOpen && (
									<CKEditor
										editor={ClassicEditor}
										data={newEmailTemplate.content || ''}
										onChange={(event, editor) => {
											const data = editor.getData();
											setNewEmailTemplate((prev) => ({ ...prev, content: data }));
										}}
										config={editorConfig}
									/>
								)}
							</Col>
						</Row>
						<h6 className="border-bottom pb-2 mb-2 mt-4">{t("emailsSistem.ingilizce")}</h6>
						<p className="small text-muted">{t("emailsTemplates.ingilizceKurali")}</p>
						<Row className="mb-3">
							<Col md="12">
								<Input
									type="text"
									name="titleEn"
									placeholder={t("emailsTemplates.baslikIngilizce")}
									value={newEmailTemplate.titleEn}
									onChange={(e) => setNewEmailTemplate(prev => ({ ...prev, titleEn: e.target.value }))}
								/>
							</Col>
						</Row>
						<Row className="mb-3">
							<Col md="12">
								{modalOpen && (
									<CKEditor
										editor={ClassicEditor}
										data={newEmailTemplate.contentEn || ''}
										onChange={(event, editor) => {
											const data = editor.getData();
											setNewEmailTemplate((prev) => ({ ...prev, contentEn: data }));
										}}
										config={editorConfig}
									/>
								)}
							</Col>
						</Row>
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={handleSave}>
							{editingId ? t("emailsTemplates.guncelle") : t("common:ekle")}
						</Button>
						<Button color="primary" onClick={toggleModal}>{t("common:iptal")}</Button>
					</ModalFooter>
				</Modal>
				<Modal isOpen={deleteModalOpen} toggle={toggleDeleteModal}>
					<ModalHeader toggle={toggleDeleteModal}>{t("emailsTemplates.onay")}</ModalHeader>
					<ModalBody>{t("emailsTemplates.buEmailSablonunuSilmekIstediginizden")}</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={confirmDelete}>{t("common:sil")}</Button>
						<Button color="primary" onClick={toggleDeleteModal}>{t("common:iptal")}</Button>
					</ModalFooter>
				</Modal>
				{/* #583: preview in Turkish / English */}
				<Modal isOpen={Boolean(onizleme)} toggle={() => setOnizleme(null)} size="lg">
					<ModalHeader toggle={() => setOnizleme(null)}>{onizleme ? t("emailsSistem.onizlemeBaslik", { anahtar: onizleme.baslik }) : ""}</ModalHeader>
					<ModalBody>
						{onizleme && (
							<>
								<ButtonGroup className="mb-3">
									<Button color={onizleme.dil === 1 ? "primary" : "light"} onClick={() => onizlemeAc(onizleme.id, onizleme.baslik, 1)}>{t("emailsSistem.turkce")}</Button>
									<Button color={onizleme.dil === 2 ? "primary" : "light"} onClick={() => onizlemeAc(onizleme.id, onizleme.baslik, 2)}>{t("emailsSistem.ingilizce")}</Button>
								</ButtonGroup>
								{onizleme.yukleniyor && <div><Spinner size="sm" className="me-2" />{t("common:yukleniyor")}</div>}
								{onizleme.hata && <Alert color="danger">{onizleme.hata}</Alert>}
								{onizleme.veri && (
									<>
										{onizleme.dil === 2 && onizleme.veri.language_id !== 2 && <Alert color="warning" className="py-2">{t("emailsSistem.onizlemeTurkceGider")}</Alert>}
										<p className="mb-2"><span className="text-muted">{t("emailsSistem.konu")}: </span><strong>{onizleme.veri.title}</strong></p>
										<iframe
											title={t("emailsSistem.onizlemeIframe")} sandbox="" srcDoc={onizleme.veri.content || ""}
											style={{ width: '100%', minHeight: 420, border: '1px solid var(--vz-border-color, #dee2e6)', borderRadius: 4, background: '#fff' }}
										/>
									</>
								)}
							</>
						)}
					</ModalBody>
				</Modal>
				</>) : (
					<SistemSablonlari />
				)}
			</Container>
		</div>
	);
};

export default Templates;
